import { Accordion, styled } from "@material-ui/core";

const CustomAccordion = styled(Accordion)(({ theme }) => {
  return {
    boxShadow: "2px 4px 4px 0px rgba(0, 0, 0, 0.1)",
    border: "none",
    borderRadius: "24px",
    minHeight: "86px",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    ".MuiAccordionDetails-root": {},
    "&.MuiAccordion-root:before": {
      backgroundColor: "white",
    },
    ".MuiAccordionSummary-root": {},
  };
});

export default CustomAccordion;
